define("views/abstract-comments/comments", [
  "globals",
  "backbone"
], function (globals, Backbone) {
  "use strict";

  return Backbone.View.extend({
    events: {
      "click [data-action = show-form]": "showForm",
    },

    initialize: function (options) {
      this.collection.on("create:comment", this.onNewComment, this);
      this.collection.on("edit:comment", this.onNewComment, this);
      if (!globals.onCoverPage()) {
        globals.content.once("sync", this.render, this);
      }

      var instance = this
      $(document.getElementById("highlightbutton")).on("click", function () {
        instance.showForm().bind(instance);
      });

      globals.content.on("update", this.render, this);
      this.name = options.name;
      return this;
    },

    render: function () {
      if (!globals.onCoverPage()) this.$el.show();
      // The comments for the current page returned in the JSON reply when
      // we load the content for the current page, so we can use them to
      // reset the collection. This means we don't need to do a separate
      // HTTP request for the comments.

      var comments = globals.content.get(this.name);
      this.collection.reset(comments);

      this.$("h2").after(this.createListView().render().el);

      this.showHighlights(comments);
      $(document.getElementById("highlight-indicator")).hide();
      $(document.getElementById("highlight")).val("");

      $(document).off("click", ".highlight");
      $(document).on("click", ".highlight", this.scrollToContent());

      return this;
    },

    onNewComment: function (comment) {
      this.showHighlights([comment.attributes]);
    },

    showHighlights: function (comments) {
      if (comments === undefined) return this;
      var self = this;
      comments.forEach(function (comment) {
        $(document.getElementById(comment.created)).remove();
        if (comment.highlight) {
          setTimeout(function () {
            var type = JSON.parse(comment.highlight).type;
            if (type == "text") {
              self.showTextHighlight(JSON.parse(comment.highlight), comment.created, comment.author.name, comment.content);
            } else if (type == "image") {
              self.showImageHighlight(JSON.parse(comment.highlight), comment.created, comment.author.name, comment.content);
            }
          }, 250);
        }
      });

      return this;
    },

    showTextHighlight: function (highlight, id, author, comment) {
      if (highlight.uiDataHtml === undefined) highlight.uiDataHtml = highlight.uiData;
      var tagList = document.getElementById("main-container").querySelectorAll(highlight.startNodeTagName + "," + highlight.endNodeTagName)
      var matchingList = [];

      var include = false;
      for (var item = 0; item < tagList.length; item++) {
        if (tagList[item].tagName == highlight.startNodeTagName && (tagList[item].innerText == highlight.startContainer)
          || tagList[item].innerHTML == highlight.startContainer
          || tagList[item].innerHTML.substring(0, tagList[item].innerHTML.indexOf("<")) == highlight.startContainer.innerHTML
          || tagList[item].innerText.replace(/\s/g, "") == this.cutHighlights(highlight.startContainer)) {
          include = true;
        }

        if (include) {
          matchingList.push(tagList[item]);
        }

        if (tagList[item].tagName == highlight.endNodeTagName && (tagList[item].innerText == highlight.endContainer)
          || tagList[item].innerHTML == highlight.startContainer
          || tagList[item].innerHTML.substring(0, tagList[item].innerHTML.indexOf("<")) == highlight.startContainer.innerHTML
          || tagList[item].innerText.replace(/\s/g, "") == this.cutHighlights(highlight.startContainer)) {
          break;
        }
      }

      if (matchingList.length === 0) {
        return this;
      }

      var span = document.createElement("a");
      span.style.backgroundColor = "transparent";
      span.className = "highlight";
      span.id = id;
      span.title = author + ": " + comment;
      span.innerHTML = "<i class=\"fa fa-comment\" aria-hidden=\"true\"></i>";

      if (highlight.startContainer !== highlight.endContainer) {
        for (var i = 0; i < matchingList.length; i++) {
          if (i === 0) {
            var pre = matchingList[i].innerHTML.substring(0, highlight.startOffset);
            // span.innerHTML = matchingList[i].innerHTML.substring(highlight.startOffset);
            var post = matchingList[i].innerHTML.substring(highlight.startOffset)
            matchingList[i].innerHTML = pre + span.outerHTML + matchingList[i].innerHTML.substring(highlight.startOffset);
          } else if (i == matchingList.length - 1) {
            // span.innerHTML = matchingList[i].innerHTML.substring(0, highlight.endOffset);
            var post = matchingList[i].innerHTML.substring(highlight.endOffset);
            matchingList[i].innerHTML = matchingList[i].innerHTML.substring(0, highlight.endOffset) + span.outerHTML + post;
          } else {
            // span.innerHTML = matchingList[i].innerHTML;
            matchingList[i].innerHTML = span.outerHTML;
          }
        }
      } else {
        var element = matchingList[0].innerHTML;
        var matches = this.countMatches(this.cutHighlights(element), this.cutHighlights(highlight.uiDataHtml.trim()));
        var matchesInComments = matches - this.countMatches(this.cutHighlights(element), this.cutHighlights(highlight.uiData.trim()));
        var index = 0;

        if (matches === 0) return this;
        else if (matches === 1) index = element.indexOf(highlight.uiDataHtml.trim());
        else {
          var highlightCount = (element.match(/highlight/g) || []).length;
          index = this.indexOf(element, highlight.uiDataHtml.trim(), highlightCount + 1 + matchesInComments)
        }

        var pre = element.substring(0, index);
        // span.innerHTML = '<i class="fa fa-comment" aria-hidden="true"></i>';
        var post = element.substring(index + highlight.uiDataHtml.length);
        element = pre + span.outerHTML +  highlight.uiDataHtml + post;
        matchingList[0].innerHTML = element;
      }

      return this;
    },

    scrollToContent: function () {
      return function (target) {
        var id = "c-" + target.target.parentNode.id;
        var el = document.getElementById(id).parentElement.parentElement.parentElement;
        el.scrollIntoView(false);
        $("#" + id).parent().parent().parent().effect("highlight", { color: "orange" }, 1000);
        window.scrollBy(0, 100);
      }
    },

    showImageHighlight: function (highlight, id, author, comment) {
      var cDoc = document.getElementsByTagName("main");
      var tagList = cDoc[0].getElementsByTagName(highlight.nodeTagName);
      var image = null;

      for (var i = 0; i < tagList.length; i++) {
        tagList[i].id = "img-" + i;
      }
      image = document.getElementById(highlight.src);

      var a = document.createElement("a")

      var div = document.createElement("div");
      div.id = id;

      div.style.setProperty("position", "absolute");
      div.style.setProperty("background", "rgba(255, 255, 0, .5)");
      div.style.setProperty("width", highlight.width);
      div.style.setProperty("height", highlight.height);
      div.style.setProperty("margin-left", highlight.leftMargin);
      div.style.setProperty("margin-top", highlight.topMargin);
      div.title = author + ": " + comment;

      a.innerHTML = div.outerHTML;
      image.outerHTML = a.outerHTML + image.outerHTML;
      $("#" + id).on("click", this.scrollToContent("c-" + id));
    },

    showForm: function (e) {
      $(document.getElementById("highlight")).hide();
      $(document.getElementById("show-form")).hide();
      var formView = this.createFormView();
      this.listenToOnce(formView, "reset", this.restore);
      $(document.getElementById("attach-form")).show();
      $(document.getElementById("comment-form")).show();
      this.highlight();
      formView.render();
      return this;
    },

    restore: function () {
      this.$("button").show();
      return this;
    },

    highlight: function (e) {
      var json = {};
      var range = null;
      var selection = window.getSelection();
      var img = document.getElementById("image-highlight");

      if (selection.focusNode) {
        range = selection.getRangeAt(0);
      }

      if (window.getComputedStyle(document.getElementById("highlightbutton")).display === "none") {
        $(document.getElementById("highlight-indicator")).hide();
        return;
      }

      if (img) {
        json.type = "image";
        json.width = img.style.width;
        json.height = img.style.height;
        json.leftMargin = img.style["margin-left"];
        json.topMargin = img.style["margin-top"];
        json.uiData = "image";
        json.nodeTagName = "img";
        json.src = img.getAttribute("name");
      } else if (range.toString()) {
        json.type = "text";
        json.startOffset = range.startOffset;
        json.endOffset = range.endOffset;
        if (range.startContainer.outerHTML == "undefined") {
          json.startContainer = range.startContainer.data;
        } else {
          json.startContainer = range.startContainer.parentElement.innerHTML;
        }
        if (range.endContainer.outerHTML == "undefined") {
          json.endContainer = range.endContainer.data;
        } else {
          json.endContainer = range.endContainer.parentElement.innerHTML;
        }
        
        json.uiData = range.toString();
        json.uiDataHtml = this.getSelectionHtml();

        if(json.uiDataHtml === null) json.uiDataHtml = json.startContainer;
        var mainContainer = document.getElementById("main-container")
        var matches = this.countMatches(mainContainer.innerHTML, json.uiDataHtml);

        if (matches === 1) {
          json.startOffset = range.startContainer.parentElement.innerHTML.indexOf(json.uiDataHtml);
          json.startNodeTagName = range.startContainer.parentElement.tagName;
          json.endNodeTagName = range.endContainer.parentElement.tagName;
        } else {
          var startContainer = range.startContainer;

          do {
            if (startContainer != null && startContainer.previousSibling != null && startContainer.previousSibling.textContent != null) {
              json.startOffset += startContainer.previousSibling.textContent.length;
            }
            startContainer = startContainer.parentElement;
            matches = this.countMatches(this.cutHighlights(mainContainer.innerHTML), this.cutHighlights(json.uiDataHtml.innerHTML));
          } while (matches > 1 && startContainer.tagName == range.startContainer.tagName)

          json.startContainer = startContainer.innerHTML;
          json.endContainer = json.startContainer
          json.startOffset = this.caretOffset(range, startContainer);
          json.startNodeTagName = startContainer.tagName;
          json.endNodeTagName = startContainer.tagName;
        }
        
        json.endOffset = json.startOffset + json.uiDataHtml.length;
        json.innerHTML = range.startContainer.parentElement.innerHTML;
        if (range.startContainer.nextElementSibling !== null && range.startContainer.nextElementSibling.tagName == "BR") {
          json.startContainer = range.startContainer.parentElement.innerHTML;
          json.endContainer = range.endContainer.parentElement.innerHTML;
          json.endOffset += range.startContainer.data.length + range.startContainer.nextElementSibling.outerHTML.length;
        }
      }

      document.getElementById("highlight").value = JSON.stringify(json);
      $(document.getElementById("highlight-indicator")).show();
      $(document.getElementById("highlight-text")).text(json.uiData);
      return this;
    },

    countMatches: function (source, term) {
      var pos = 0;
      var count = -1;

      while (pos != -1) {
        pos = source.indexOf(term.trim(), pos + 1);
        count++;
      }

      if (count < 1 && source.trim().includes(term.trim())) {
        count = 1;
      }

      return count;
    },

    caretOffset: function (range, element) {
      var caretOffset = 0;
      var selected = range.toString().length;
      var preCaretRange = range.cloneRange();
      preCaretRange.selectNodeContents(element);
      preCaretRange.setEnd(range.endContainer, range.endOffset);

      if (selected) {
        caretOffset = preCaretRange.toString().length - selected;
      } else {
        caretOffset = preCaretRange.toString().length;
      }

      return caretOffset;
    },

    cutHighlights: function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var tagList = doc.querySelectorAll(".highlight");
      var str = "";

      if (tagList.length > 0) {
        tagList.forEach(function (element) {
          element.parentNode.replaceChild(document.createTextNode(element.innerText), element);
          var s = 1
        })
      }

      doc.childNodes.forEach(function (node) {
        str += node.innerText;
      })

      var ret = str.replace(/\s/g, "");

      return ret.replaceAll(" ", "");
    },

    indexOf: function (string, substring, index) {
      return string.split(substring, index).join(substring).length;
    },

    getSelectionHtml: function () {
      var html = "";
      if (typeof window.getSelection != "undefined") {
        var sel = window.getSelection();
        if (sel.rangeCount) {
          var container = document.createElement("div");
          for (var i = 0, len = sel.rangeCount; i < len; ++i) {
            container.appendChild(sel.getRangeAt(i).cloneContents());
          }     
          do {
            if(container.firstChild.data) {
              html = container.firstChild.data.trim();
            } else {
              html = container.firstChild.outerText.trim();
            }
            container.removeChild(container.firstChild)
          } while(html.length < 3 && container.firstChild)
          
          if(html.length < 3) html = null;
        }
      } else if (typeof document.selection != "undefined") {
        if (document.selection.type == "Text") {
          html = document.selection.createRange().htmlText;
        }
      }
      return html;
    }
  });
});

